import { faExclamationTriangle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { Button, Col, Row, Form, Alert, Container } from "react-bootstrap";
import { FormField, Radio } from "semantic-ui-react";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import ActiveUserPass from "../../../components/passes/ActiveUserPass";
import GoBackBtn from "../../../components/buttons/GoBackBtn";

const ChangePassAttachment = () => {
    const { checkServerData, setAlerts, goBack, showView, changeView } = useContext(BasicContext);
    const student = showView.params.student;
    const [userPasses, setUserPasses] = useState(null);
    const [loading, setLoading] = useState(true);
    const [blockForm, setBlockForm] = useState(false);
    const [selectedPass, setSelectedPass] = useState(null);
    const [formChanged, setFormChanged] = useState(false);
    const [warningInfo, setWarningInfo] = useState(null);

    const getUserPasses = async () => {
        const res = await postMethod("/get-user-active-passes-without-current", { upID: student.up_id, studentID: student.user_id, classID: student.class_id });
        if (checkServerData(res)) {
            if (res.data.list.length === 0) setWarningInfo(t(`warning.${res.data.warningCode}`));
            else setUserPasses(res.data.list);

            setLoading(false);
        }
    };

    const reattachingPass = async () => {
        const res = await postMethod("/reattaching-pass", {
            selectedPassID: selectedPass,
            u2cID: student.u2c_id,
            userID: student.user_id,
            currentPassID: student.up_id,
            className: student.class_name,
            classStartTime: student.class_start_time,
        });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 2500, id: "reattachingPassAlert" }]);
            changeView({ nav: "schedule", sub: "checkAttendance", params: { class: showView.params.classData, changedData: true } });
        }
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (!selectedPass && !blockForm) errors.push(t("error.noCheckedPass"));

        if (errors.length > 0) {
            setAlerts([
                {
                    variant: "danger",
                    message: (
                        <div>
                            <p>{t("appearedErrors")}:</p>
                            <p>
                                {errors.map((e, i) => (
                                    <span key={i}>
                                        {e}
                                        {i + 1 < errors.length ? <br /> : ""}
                                    </span>
                                ))}
                            </p>
                        </div>
                    ),
                },
            ]);
        } else {
            setAlerts([{ variant: "info", message: t("info.reattachingPass") }]);
            setBlockForm(true);
            reattachingPass();
        }
    };

    useEffect(() => {
        getUserPasses();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <GoBackBtn />
            <Form onSubmit={checkValidation} autoComplete="off">
                <Container fluid="lg">
                    <Row>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <h1 className="h5 d-inline-block m-0 pt-2">{t("classes.reattachingEntranceOnAnotherPass")}</h1>
                        </Col>
                    </Row>

                    {loading ? (
                        <Row>
                            <Col className="text-center">
                                <p className="h6">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            {userPasses ? (
                                <Fragment>
                                    <Col xs={12} lg={6}>
                                        <Form.Group id={`activeUserPasses`}>
                                            <Form.Label>
                                                <strong>{t("passes.chooseActivePass")}</strong>
                                            </Form.Label>
                                            {userPasses.map((e, i) => (
                                                <FormField key={i} className={`active-user-pass ${e.up_paid !== e.up_price && e.up_price > 0 ? "user-pass-not-paid" : ""}`}>
                                                    <Radio
                                                        disabled={blockForm}
                                                        label={
                                                            <label className={!e.up_activation_date ? "no-activation-date" : ""}>
                                                                <ActiveUserPass pass={e} i={i} />
                                                            </label>
                                                        }
                                                        name="radioGroup"
                                                        value={e.up_id}
                                                        checked={selectedPass === e.up_id}
                                                        onChange={() => {
                                                            setSelectedPass(e.up_id);
                                                            setFormChanged(true);
                                                        }}
                                                    />
                                                </FormField>
                                            ))}
                                        </Form.Group>
                                    </Col>
                                </Fragment>
                            ) : !userPasses && warningInfo ? (
                                <Col>
                                    <Alert variant="warning">
                                        <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                                        {warningInfo}
                                    </Alert>
                                </Col>
                            ) : null}
                        </Row>
                    )}

                    <Row className="sticky-bottom bg-light-primary">
                        <Col xs={6}>
                            <Button variant="primary" className="px-4 mt-4 mb-4" type="submit" disabled={blockForm || !formChanged}>
                                {t("reattach")}
                            </Button>
                        </Col>
                        <Col xs={6} className="text-end">
                            <Button variant="outline-secondary" className="px-4 mt-4 mb-4" onClick={() => goBack()}>
                                {t("cancel")}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </Fragment>
    );
};

export default ChangePassAttachment;
